<template>
  <div>
    <qx-card
      :title="(type || $route.query.type) === 'approve' ? '审核车辆' : '查看车辆'"
      class="detail"
      v-loading="loading"
    >
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
        label-width="200px"
      >
        <span slot="plateNumber" slot-scope="prop">
          <span
            >{{ prop.data.plateNumber
            }}<em class="auth-state no">{{ prop.data.authStateName }}</em></span
          >
        </span>
        <span slot="isUseCarOilCost" slot-scope="prop">
          <span>{{ prop.data.isUseCarOilCost ? '是' : '否' }}</span>
        </span>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : `${detailRes.relId}`"
      busiCode="100005"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  getAllVehicleInfo, // 获取详情
  getAllVehicleInfoVerAudit, // 获取审核详情
  getAllVehicleInfoVer, // 车辆 ver 详情
} from 'api/car';
import {
  getFileUrl,
  approveItemInfo,
} from 'api';
import ApproveBox from 'components/approveBox';
import {normalizeFileResponseItems} from 'api/fileResponseCompat';
import detailDataInit from './detailDataInit';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: null,
    },
  },
  data () {
    return {
      verState: '',
      vehicleCode: '',
      vehicleClass: '',
      plateNumber: '',
      pageTitle: '查看车辆',
      loading: false,
      detailRes: {},
      detailData: {},
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    decodePlateNumber () {
      if (this.plateNumber) {
        return this.plateNumber;
      } else if (this.$route.query.plateNumber) {
        return decodeURIComponent(this.$route.query.plateNumber);
      } else {
        return '';
      }
    },
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    // 设置详情数据
    setDetailData (detailRes, type = 'data') {
      // 有一些字段名字是对象的，得改个别名处理一下
      if (detailRes.ext) {
        detailRes.axleNumber = detailRes.ext.axleNumber;
        detailRes.driveTypeName = detailRes.ext.driveTypeName;
        detailRes.brandModelExt = detailRes.ext.brandModel;
        detailRes.vehicleOriginName = detailRes.ext.vehicleOriginName;
        detailRes.maintainMethodName = detailRes.ext.maintainMethod === 1 ? '按时间' : '按累计里程';
        detailRes.nextMaintainTime = detailRes.ext.nextMaintainTime;
        detailRes.maintainWaringDay = detailRes.ext.maintainWaringDay;
        detailRes.accumulatedMileage = detailRes.ext.accumulatedMileage;
        detailRes.mileageDriven = detailRes.ext.mileageDriven;
      }
      for (let item in this.detailData) {
        if (this.detailData[item]) {
          this.detailData[item].tableData[type] = detailRes;
        }
      }
    },
    // 设置详情信息和详情审核信息数据
    setDetailAndDetailVerData (detailRes, detailVerRes) {
      this.setDetailData(detailRes, 'data');
      if (detailVerRes) {
        this.setDetailData(detailVerRes, 'approveData');
      }
    },
    // 根据车辆类型设置对应的展示数据
    setDetailDataByVehicleClass (detailRes) {
      if (detailRes.vehicleClass === 3) {
        // 如果是外调车，只需要展示基础信息和车辆参数的一部分字段
        this.detailData = detailDataInit.outward;
      } else if (detailRes.vehicleClass === 2 || detailRes.vehicleClass === 4) {
        this.detailData = JSON.parse(JSON.stringify(detailDataInit.normal));
        delete this.detailData.maintanceInfo;
      } else {
        // 如果不是外调车，展示全部字段
        this.detailData = detailDataInit.normal;
      }
      this.detailRes = detailRes;
      this.$emit('vehicleInfo', detailRes);
    },
    // 通过图片 id 查找对应的 url
    async findImgUrlById (detailRes) {
      const aImgName = ['drivingLicense', 'adriverLicenseCopy', 'carRegistrationPicture', 'vehiclePicture', 'specialOperCertFileId', 'gasificationCertificate'];
      let flowIds = [];
      for (let imgItem of aImgName) {
        if (detailRes[imgItem]) {
          flowIds.push(detailRes[imgItem]);
        }
      }
      const imgRes = await getFileUrl({
        flowIds: flowIds.join(),
      });
      for (let imgItem of aImgName) {
        const imgItems = normalizeFileResponseItems(imgRes);
        imgItems.forEach((item) => {
          if (`${item.flowId}` === `${detailRes[imgItem]}`) {
            detailRes[imgItem + 'Url'] = item.fullPath;
          } else {
            detailRes.carRegistrationPicture ? String(detailRes.carRegistrationPicture).split(',').forEach((itemFlowId, index) => {
              if (String(item.flowId) === itemFlowId) {
                detailRes['pic' + index] = item.fullPath;
              }
            }) : '';
          }
        });
      }
    },
    async getData () {
      if (
        this.$route.path !== '/manage/car/archives/my/detail' && this.$route.path !== '/manage/car/archives/my/detailRecord' && this.$route.path !== '/manage/car/archives/record/detail' &&
        !this.id
      ) {
        return;
      }
      this.loading = true;
      if ((this.type && this.$route.query.type) === 'approve') {
        // 只是显示 ver 接口的数据
        const resDetailResVer = await getAllVehicleInfoVer({
          // 查看历史记录为 9
          verState: this.verState || this.$route.query.verState || 1,
          vehicleCode: this.vehicleCode || this.$route.query.id || -1,
        });
        this.loading = false;
        if (!resDetailResVer.failed) {
          this.setDetailDataByVehicleClass(resDetailResVer);
          await this.findImgUrlById(resDetailResVer);
          this.setDetailAndDetailVerData(resDetailResVer, {});
        }
      } else {
        // 显示详情的数据，用 ver 接口的数据对比详情接口数据
        let detailRes;
        if (!this.$route.query.verState) {
          detailRes = await getAllVehicleInfo({
            vehicleCode: this.vehicleCode || this.$route.query.id || -1,
            vehicleClass: this.vehicleClass || this.$route.query.vehicleClass || '',
            plateNumber: this.decodePlateNumber,
          });
        } else {
          detailRes = await getAllVehicleInfoVer({
            verState: 9,
            vehicleCode: this.vehicleCode || this.$route.query.id || -1,
            vehicleClass: this.vehicleClass || this.$route.query.vehicleClass || '',
            plateNumber: this.decodePlateNumber,
          });
        }
        this.setDetailDataByVehicleClass(detailRes);
        const detailVerRes = await getAllVehicleInfoVerAudit({
          // 查看历史记录为 9
          verState: this.$route.query.verState || 1,
          vehicleCode: this.vehicleCode || this.$route.query.id || -1,
          vehicleClass: detailRes.vehicleClass || '',
          plateNumber: this.decodePlateNumber,
        });
        this.loading = false;
        if (!detailRes.failed) {
          // 重置一下展示的字段长度，防止来回切换 tab 的时候图片字段不断增多
          this.detailData.base.tableData.title.length = 8;
          if (detailRes.carRegistrationPicture) {
            for (let i = 0; i < detailRes.carRegistrationPicture.split(',').length; i++) {

              this.detailData.base.tableData.title.push({
                prop: 'pic' + i,
                label: '车辆登记证书图片' + (i + 1),
                type: 'img',
              });
            }
          } else {
            this.detailData.base.tableData.title.push({
              prop: 'pic',
              label: '车辆登记证书图片',
              type: 'img',
            });
          }
          this.detailData.base.tableData.title.push({
            prop: 'vehiclePictureUrl',
            label: '车辆图片',
            type: 'img',
          });
          if (detailRes.energyType === 'E') {
            this.detailData.base.tableData.title.push({
              prop: 'gasificationCertificateUrl',
              label: '加气证',
              type: 'img',
            });
          }


          if (this.detailData.maintanceInfo) {
            this.detailData.maintanceInfo.tableData.title.length = 1;
            const detailExt = detailRes.ext || {};
            if (detailExt.maintainMethod) {
              if (detailExt.maintainMethod === 1) {
                if (this.detailData.maintanceInfo.tableData.title.find((item) => item.prop !== 'nextMaintainTime')) {
                  this.detailData.maintanceInfo.tableData.title.push({
                    label: '下次保养时间',
                    prop: 'nextMaintainTime',
                  });
                }
                if (this.detailData.maintanceInfo.tableData.title.find((item) => item.prop !== 'maintainWaringDay')) {

                  this.detailData.maintanceInfo.tableData.title.push({
                    label: '到期预警天数',
                    prop: 'maintainWaringDay',
                  });
                }
              }
              if (detailExt.maintainMethod === 2) {
                if (this.detailData.maintanceInfo.tableData.title.find((item) => item.prop !== 'accumulatedMileage')) {
                  this.detailData.maintanceInfo.tableData.title.push({
                    label: '下次保养里程数（km）',
                    prop: 'accumulatedMileage',
                  });
                }
                if (this.detailData.maintanceInfo.tableData.title.find((item) => item.prop !== 'mileageDriven')) {
                  this.detailData.maintanceInfo.tableData.title.push({
                    label: '已行驶里程（km）',
                    prop: 'mileageDriven',
                  });
                }
              }
            }
          }


          // 根据详情接口返回的图片 id 获取图片对应的 url
          await this.findImgUrlById(detailRes);
          this.setDetailAndDetailVerData(detailRes, detailVerRes);
        }
      }
    },
  },
  async mounted () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 100005,
      });
      this.verState = res.verState;
      this.vehicleCode = res.vehicleCode;
      this.vehicleClass = res.vehicleClass;
      this.plateNumber = res.plateNumber;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
.auth-state {
  padding-left: 10px;
}
.no {
  color: red;
}
</style>
